import { ajax } from "lib/observable";
import { Observable } from "rxjs";
import "rxjs/add/operator/map";
import { PAYMENTS_MANAGEMENT } from "constants/action-types";
import siteConfig from "site-config";
import { updateEntities } from "redux-query";
import * as qs from "qs";
import { getRecordsFromSchema, normalizeData } from "lib/api";
import { Transactions as TransactionsSchema } from "schemas/payments";
import { FileExport as FileExportSchema } from "schemas/files";
import { push } from "react-router-redux";

export const fetchTransactionsEpic = (action$, store) =>
    action$.ofType(PAYMENTS_MANAGEMENT.TRANSACTIONS.FETCH.START).mergeMap(({ payload }) => {
        const { scope, transactions } = store.getState();
        const { accountId, date, direction } = payload;

        const queryParams = {
            __limit: 30,
            __sort: "transaction_date",
            __sort_order: "desc",
            transaction_date_gte: date.startOf("day").valueOf(),
            transaction_date_lte: date.endOf("day").valueOf(),
            __populate: "__daily_rollup",
            transaction_amount: 0,
        };

        const defaultUrl = `${siteConfig.api}/api/v3.0/transactions/deposits/account/${accountId}?${qs.stringify(
            queryParams
        )}`;

        let url = defaultUrl;
        if (transactions.meta && transactions.meta[direction]) {
            url = `${siteConfig.api}${transactions.meta[direction]}`;
        }

        return ajax(url)
            .flatMap(({ response, status, xhr }) => {
                const { data, aggregateData } = response;
                const records = getRecordsFromSchema(TransactionsSchema);
                const normalizedData = normalizeData(data, TransactionsSchema, records);
                const next = xhr.getResponseHeader("Next");
                let previous = transactions.meta.current;

                if (defaultUrl === url) {
                    previous = null;
                } else if (!transactions.meta.previous && url !== defaultUrl) {
                    previous = defaultUrl.replace(siteConfig.api, "");
                }

                return [
                    updateEntities({
                        transactions: (current) => {
                            return {
                                ...current,
                                ...normalizedData.entities.transaction,
                            };
                        },
                    }),
                    {
                        payload: normalizedData.result,
                        type: PAYMENTS_MANAGEMENT.TRANSACTIONS.FETCH.COMPLETED,
                        meta: {
                            next,
                            current: url.replace(siteConfig.api, ""),
                            previous,
                            aggregateData,
                        },
                    },
                ];
            })
            .catch((error) => {
                return Observable.merge(
                    Observable.of({
                        error: true,
                        payload: error,
                        type: PAYMENTS_MANAGEMENT.TRANSACTIONS.FETCH.COMPLETED,
                    })
                );
            });
    });

export const createDailyTransactionDownloadEpic = (action$, store) =>
    action$.ofType(PAYMENTS_MANAGEMENT.TRANSACTIONS.DOWNLOAD_CREATE.START).mergeMap(({ payload }) => {
        const { scope } = store.getState();
        return ajax({
            method: "POST",
            body: {
                format: "daily_transactions",
                file_type: "xlsx",
                options: {
                    account_id: payload.account_id,
                    currency_code: payload.currency_code,
                    date: payload.date.valueOf(),
                },
            },
            url: `${siteConfig.api}/api/v3.0/files/export`,
        })
            .flatMap(({ response, status, xhr }) => {
                const records = getRecordsFromSchema(FileExportSchema);
                const data = normalizeData(response, FileExportSchema, records);

                return [
                    updateEntities({
                        fileExports: (current) => {
                            return {
                                ...current,
                                ...data.entities.fileExports,
                            };
                        },
                    }),
                    {
                        payload: [],
                        error: false,
                        type: PAYMENTS_MANAGEMENT.TRANSACTIONS.DOWNLOAD_CREATE.COMPLETED,
                    },
                    push(`/brand/${scope.brand._id}/daily-transactions/${data.result}/download`),
                ];
            })
            .catch((error) => {
                return Observable.merge(
                    Observable.of({
                        error: true,
                        payload: error,
                        type: PAYMENTS_MANAGEMENT.TRANSACTIONS.DOWNLOAD_CREATE.COMPLETED,
                    })
                );
            });
    });
